// check if values shall be selectable or not, when dimensions are rendered,
// based on current constraints
export default function getSelectableValues(dimensions, constraints) {
  return dimensions.map((dimension) => {
    const { values } = dimension

    const dimensionValues = values.map((value) => {
      const foundConstraints = constraints.find((item) => item.valueId === value.valueId)

      if (
        (foundConstraints && foundConstraints.checkStatus === 'NEED') ||
        (foundConstraints && foundConstraints.checkStatus === 'DENYFOR')
      ) {
        return {
          ...value,
          selectable: false,
        }
      } else {
        return {
          ...value,
          selectable: true,
        }
      }
    })

    return {
      ...dimension,
      values: dimensionValues,
    }
  })
}
